// ===== Rewind Collector — countdown + PDP interactions =====
(function(){
  function initCountdowns(){
    document.querySelectorAll('[data-rc-countdown]').forEach(function(el){
      if(el.dataset.timer !== 'true') return;
      var clock = el.querySelector('[data-rc-clock]');
      if(!clock) return;
      var mins = parseInt(el.dataset.minutes,10) || 20;
      var key = 'rc_timer_deadline';
      var now = Date.now();
      var deadline = parseInt(sessionStorage.getItem(key),10);
      if(!deadline || deadline < now){ deadline = now + mins*60*1000; sessionStorage.setItem(key, deadline); }
      function tick(){
        var diff = Math.max(0, deadline - Date.now());
        var m = Math.floor(diff/60000), s = Math.floor((diff%60000)/1000);
        clock.textContent = (m<10?'0':'')+m+':'+(s<10?'0':'')+s;
        if(diff>0) setTimeout(tick,1000);
      }
      tick();
    });
  }

  // Sélecteurs de taille par pièce (dropdowns) -> variante cachée
  function initPdpVariants(){
    var form = document.querySelector('.rc-pdp__buy form');
    if(!form) return;
    var master = form.querySelector('[data-rc-variants]');
    if(!master) return;
    var pieceSelects = Array.prototype.slice.call(form.querySelectorAll('[data-rc-opt]'));
    var addBtn = form.querySelector('.rc-pdp__add');
    if(!pieceSelects.length) return;

    function sync(){
      var chosen = pieceSelects.slice().sort(function(a,b){
        return parseInt(a.dataset.rcOpt,10) - parseInt(b.dataset.rcOpt,10);
      }).map(function(s){ return s.value; });
      var wanted = chosen.join(' / ');
      var matched = null;
      Array.prototype.forEach.call(master.options, function(o){
        if(o.dataset.opts === wanted){ matched = o; }
      });
      if(matched){ master.value = matched.value; }
    }
    // Au chargement : partir de la première variante disponible (évite "épuisé" par défaut)
    var firstAvail = null;
    Array.prototype.forEach.call(master.options, function(o){
      if(!firstAvail && !o.disabled){ firstAvail = o; }
    });
    if(firstAvail){
      var vals = (firstAvail.dataset.opts || '').split(' / ');
      pieceSelects.slice().sort(function(a,b){
        return parseInt(a.dataset.rcOpt,10) - parseInt(b.dataset.rcOpt,10);
      }).forEach(function(s, i){
        if(vals[i] !== undefined){ s.value = vals[i]; }
      });
    }

    pieceSelects.forEach(function(s){ s.addEventListener('change', sync); });
    sync();
  }

  // Galerie : clic vignette -> image principale
  function initPdpGallery(){
    var main = document.querySelector('[data-rc-main]');
    if(!main) return;
    document.querySelectorAll('[data-rc-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        var full = t.dataset.full;
        if(full){ main.src = full; }
        document.querySelectorAll('[data-rc-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  // Page d'entrée : compteur qui descend doucement (simulé, mémorisé par session)
  function initSplash(){
    var el = document.querySelector('[data-rc-splash]');
    if(!el) return;
    var ENTERED = 'rc_entered';
    if(sessionStorage.getItem(ENTERED)){ el.classList.add('rc-splash--gone'); return; }

    var numEl = el.querySelector('[data-rc-splash-num]');
    var counter = el.querySelector('[data-rc-splash-counter]');
    if(numEl && counter){
      var VALKEY = 'rc_splash_val';
      var val = parseInt(sessionStorage.getItem(VALKEY), 10);
      if(!val || val < 1){ val = parseInt(counter.dataset.start, 10) || 400; sessionStorage.setItem(VALKEY, val); }
      numEl.textContent = val;
      function step(){
        if(el.classList.contains('rc-splash--gone') || val <= 1) return;
        val -= 1;
        sessionStorage.setItem(VALKEY, val);
        numEl.textContent = val;
        setTimeout(step, 1200 + Math.random()*2600); // descente lente et irrégulière
      }
      setTimeout(step, 1500);
    }

    var btn = el.querySelector('[data-rc-splash-enter]');
    if(btn){
      btn.addEventListener('click', function(){
        sessionStorage.setItem(ENTERED, '1');
        el.classList.add('rc-splash--gone');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    initSplash(); initCountdowns(); initPdpVariants(); initPdpGallery();
  });
})();

/* ===== Minuteur « panier conservé 10 minutes » =====
   Purement informatif : décompte affiché dans le tiroir, aucune action sur le panier. */
(function () {
  var DUREE = 10 * 60; // secondes

  function format(s) {
    var m = Math.floor(s / 60), r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function demarrer(bloc) {
    if (bloc.__rcTimer) return;
    var champ = bloc.querySelector('[data-rc-hold-time]');
    if (!champ) return;
    var reste = DUREE;
    champ.textContent = format(reste);
    bloc.__rcTimer = setInterval(function () {
      reste -= 1;
      if (reste <= 0) {
        clearInterval(bloc.__rcTimer);
        bloc.__rcTimer = null;
        bloc.classList.add('rc-hold-bar--fini');
        champ.textContent = '0:00';
        return;
      }
      champ.textContent = format(reste);
    }, 1000);
  }

  function scruter() {
    var blocs = document.querySelectorAll('[data-rc-hold]');
    for (var i = 0; i < blocs.length; i++) demarrer(blocs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scruter);
  } else {
    scruter();
  }
  // le tiroir est re-rendu à chaque ajout : on relance le décompte sur le nouveau bloc
  new MutationObserver(scruter).observe(document.documentElement, { childList: true, subtree: true });
})();
